import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're0011',
    ecrans: ['00-2'],
    params: ['?rtocleint']
});
